<div class="modals bu-calculations-modal" [class.modals-show]="isModalShow">

  <div class="modal-header">
    <h2 class="modal-title">Взаєморозрахунки</h2>
    <a class="close-modal" (click)="closeModal()"></a>
  </div>

  <div class="modal-body">
    <div class="bu-balance-card" [class.is-debt]="balance > 0" [class.is-overpay]="balance <= 0">
      <div class="balance-icon">
        <i *ngIf="balance > 0" class="fa fa-file-text-o"></i>
        <i *ngIf="balance <= 0" class="fa fa-check-circle"></i>
      </div>
      <div class="balance-info">
        <span class="balance-label" *ngIf="balance > 0">Ваш поточний борг</span>
        <span class="balance-label" *ngIf="balance <= 0">Ваш баланс (переплата)</span>
        <span class="balance-amount">{{ (balance > 0 ? balance : balance * -1) | number:'1.2-2' }} <span>UAH</span></span>
      </div>
    </div>

    <div class="transactions-header" *ngIf="data.length > 0">
      <h3>Історія операцій</h3>
    </div>

    <ul class="bu-calc-list" *ngIf="data.length > 0">
      <li *ngFor="let buCalculationItem of data" class="bu-calc-item">
        <div class="item-icon" [ngClass]="'icon-' + buCalculationItem.doc_type">
          <i *ngIf="buCalculationItem.doc_type === 'sale'" class="fa fa-shopping-cart"></i>
          <i *ngIf="buCalculationItem.doc_type === 'return'" class="fa fa-undo"></i>
          <i *ngIf="buCalculationItem.doc_type === 'payment'" class="fa fa-credit-card"></i>
        </div>
        <div class="item-details">
          <div class="item-primary">
            <span class="item-title">
              <ng-container [ngSwitch]="buCalculationItem.doc_type">
                <span *ngSwitchCase="'sale'">Продаж</span>
                <span *ngSwitchCase="'return'">Повернення</span>
                <span *ngSwitchCase="'payment'">Оплата</span>
              </ng-container>
            </span>
            <span class="item-summa" [class.is-positive]="buCalculationItem.summa_total > 0" [class.is-negative]="buCalculationItem.summa_total < 0">
              {{ buCalculationItem.summa_total > 0 ? '+' : '' }}{{ buCalculationItem.summa_total | number:'1.2-2' }} UAH
            </span>
          </div>
          <div class="item-comment">{{ buCalculationItem.comment }}</div>
          <div class="item-meta">
            <span class="item-date">
              <i class="fa fa-calendar-o"></i>
              {{ buCalculationItem.datetime }}
            </span>
            <div class="item-tax-details" *ngIf="buCalculationItem.doc_type === 'sale' || buCalculationItem.doc_type === 'return'">
              <span class="tax-badge">Без ПДВ: {{ buCalculationItem.summa_no_vat | number:'1.2-2' }}</span>
              <span class="tax-badge">ПДВ: {{ buCalculationItem.vat_summa | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <div class="bu-no-data-state" *ngIf="data.length === 0">
      <div class="no-data-icon">
        <i class="fa fa-inbox"></i>
      </div>
      <p>Операції відсутні</p>
      <span>Тут буде відображатися історія ваших взаєморозрахунків</span>
    </div>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
